//File utils for glycan visualizer

/**
 * What does this do
 * @version 1.0.0
 * Link to reference
 * @see {@link }
 */

/**
 * Draws gridlines on VisJS canvas. 
 * @param {*} ctx 
 * @param {*} gridDensity 
 * @param {*} network 
 */
export function drawGridlines(ctx, gridDensity, network) 
{
    const gridSize = gridDensity;
    const {width, height} = ctx.canvas;
    const scale = network.getScale();
    const viewPosition = network.getViewPosition();
    ctx.strokeStyle = "#8a8a8a";
    ctx.lineWidth = 1;

    //draw vertical gridlines
    for(let x = gridSize; x < width*(1/scale) + viewPosition.x; x += gridSize)
    {
        ctx.beginPath();
        ctx.moveTo(x + gridSize/2, -height/scale+viewPosition.y);
        ctx.lineTo(x + gridSize/2, height/scale+viewPosition.y);
        ctx.stroke();
    }
    for(let x = 0; x > -width/scale + viewPosition.x; x -= gridSize)
    {
        ctx.beginPath();
        ctx.moveTo(x + gridSize/2, -height/scale+viewPosition.y);
        ctx.lineTo(x + gridSize/2, height/scale+viewPosition.y);
        ctx.stroke();
    }

    //draw horizontal gridlines
    for(let y = gridSize; y < height/scale + viewPosition.y; y += gridSize)
    {
        ctx.beginPath();
        ctx.moveTo(-width/scale+viewPosition.x, y + gridSize/2);
        ctx.lineTo(width/scale+viewPosition.x, y + gridSize/2);
        ctx.stroke();
    }
    for(let y = 0; y > -height/scale + viewPosition.y; y -= gridSize)
    {
        ctx.beginPath();
        ctx.moveTo(-width/scale+viewPosition.x, y + gridSize/2);
        ctx.lineTo(width/scale+viewPosition.x, y + gridSize/2);
        ctx.stroke();
    }      
}

/**
 * Set the zoom-scale of the VisJS canvas.
 * @param {*} scaleAmt 
 * @param {*} network
 * @param {*} pageState
 * @param {*} setPageState
 */
export function setPageScale(scaleAmt, network, pageState, setPageState)
{
    //clamp the page scale
    let computedScale = Math.min(Math.max(scaleAmt, 25), 150);
    //update the page state
    setPageState({...pageState, scale:computedScale});
    //apply change to network
    network.moveTo({scale:computedScale/100});
}